<template>
    <nav class="">
        <div class="max-w-(--breakpoint-2xl) container mx-auto px-4 md:px-6 flex flex-wrap">
            <div class="w-2/5 md:w-3/5 flex justify-start items-center text-sm">
                <div class="mr-4 relative min-h-14">
                    <img :src="totals.set_image" v-if="totals && totals.set_image" class="max-h-24" />
                    <!-- <VuePicture v-else :image="image" :style="'h-16'" :height="56" :width="56" :name="product.name" /> -->
                     <!-- Show loader -->
                    <fa v-else-if="loading" :icon="['fad', 'spinner-third']" class="text-dgreen mr-2 w-8 h-8 my-4 fa-spin" />
                </div>
                <div>
                    <span class="hidden md:block font-bold mb-1 text-base">{{ product.name }}</span>

                    <ul class="hidden md:flex flex-inline text-xs space-x-4 text-gray-600">
                        <li
                            v-for="(usp, index) in usps"
                            :key="index"
                            :hidden="(!product.returnable && index == 2) || (product.returnable && index == 3)"
                        >
                            <fa :icon="['fal', 'check']" class="text-dgreen mr-1 w-4" />
                            <span v-html="usp" />
                        </li>
                    </ul>
                    <div class="flex flex-col md:hidden w-20">
                        <div v-if="totals" class="font-bold w-fit text-lg">
                            {{ price(totals.total) }}
                        </div>
                        <span v-else class="font-bold w-fit text-lg">
                            {{ price(product.price) }}
                        </span>
                        <span class="text-xs text-gray-600">incl. BTW</span>
                    </div>
                </div>
            </div>

            <div class="w-3/5 md:w-2/5 flex justify-end items-center">
                <div class="flex items-center w-full  md:justify-end">
                    <div class="mr-4 hidden md:block">
                        <span class="inline-block">Totaal incl. BTW</span>
                        <span v-if="totals" class="font-bold ml-2">
                            {{ price(totals.total) }}
                        </span>
                        <span v-else class="font-bold ml-2">
                            {{ price(product.price) }}
                        </span>
                    </div>
                    <button @click="emit('submit')" class="button w-full md:w-fit green">
                        <span v-if="totals">
                            <fa
                                :icon="['fad', 'spinner-third']"
                                class="text-white opacity-80 mr-2 fa-spin"
                                v-if="loading"
                            />
                            <fa v-else :icon="['fal', 'shopping-cart']" class="text-white mr-2" />
                            In winkelwagen
                        </span>
                            
                        <span v-else>
                            Samenstellen
                            <fa :icon="['fal', 'chevron-right']" class="text-white ml-2" />
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </nav>
</template>

<script setup>
import { useAppStore } from '@/stores/appStore';
import { computed } from 'vue';

const emit = defineEmits(['submit'])
const $appStore = useAppStore();
defineProps({
    totals: [Object, Boolean],
    loading: Boolean,
    image: Object,
    product: Object,
});

const usps = computed(() => {
    let settings = $appStore.settings;  
    return [settings['usp-1'], settings['usp-2'], settings['usp-3'], settings['usp-4']];
});

</script>
